import React from "react"
import {
  Modal,
  IModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  ModalFooter,
} from "@chakra-ui/core"
import Heading from "../typography/Heading"
import Stars from "../Stars"
import Review from "../Review"
import { JudgeMeReview } from "../../typings"
import Body from "../typography/Body"
import { Button } from "../Buttons"
import ReviewForm from "../ReviewForm"
import ModalCloseButton from "../Buttons/ModalCloseButton"
import { bp } from "../../utils/MediaQueries"

type ReviewsModalProps = Omit<IModal, "children"> & {
  bikeName: string
  rating?: number
  reviews?: JudgeMeReview[]
  productId?: number
  loadMoreReviews?: VoidFunction
  isLoadingMore?: boolean
}

export default function ReviewsModal({
  bikeName,
  rating = 0,
  reviews = [],
  loadMoreReviews,
  isLoadingMore,
  productId,
  ...props
}: ReviewsModalProps) {
  const [state, setState] = React.useState<"read" | "write">("read")
  return (
    <Modal size="xl" isCentered scrollBehavior="inside" {...props}>
      <ModalOverlay />
      <ModalContent
        width={bp("100%", "60vw")}
        maxWidth={["100%", null, null, null, "60rem"]}
        height="auto"
        maxHeight={bp("100%", "80vh")}
        borderRadius="0.5rem"
        px={bp("1.5rem", "1rem")}
        py="2rem"
        mx={bp("1.25rem")}
      >
        <ModalCloseButton size="lg" />

        <ModalHeader px={bp("0", "6.125rem")} mb="1rem">
          {state === "read" && (
            <Flex align="center" mb="0.75rem">
              <Heading as="h3" size="3" mr="1rem">
                Reviews
              </Heading>
              <Stars value={rating} />
            </Flex>
          )}
          {state === "write" && (
            <Heading as="h3" size="3">
              Write a Review
            </Heading>
          )}
          <Body>{bikeName}</Body>
        </ModalHeader>
        <ModalBody px={bp("0", "6.125rem")}>
          {state === "read" && (
            <>
              {reviews.length === 0 && (
                <Body color="dusk" p="1rem">
                  No reviews yet
                </Body>
              )}
              {reviews.map((review, index) => (
                <Review
                  key={review.id}
                  title={review.title}
                  body={review.body}
                  reviewer={review.reviewer.name}
                  rating={review.rating}
                  date={review.created_at}
                  py="2rem"
                  borderBottom={
                    index < reviews.length - 1 ? "1px solid" : "0px"
                  }
                  borderColor="dividerLine"
                />
              ))}
              {loadMoreReviews && (
                <Button
                  theme="secondary"
                  onClick={loadMoreReviews}
                  isLoading={isLoadingMore}
                >
                  Load More
                </Button>
              )}
            </>
          )}
          {state === "write" && productId && (
            <ReviewForm productId={productId} />
          )}
        </ModalBody>
        <ModalFooter px={bp("0", "6.125rem")} mt="1rem">
          {state === "read" && productId && (
            <Button w={bp("100%", "auto")} onClick={() => setState("write")}>
              Write a review
            </Button>
          )}
          {state === "write" && (
            <Button w={bp("100%", "auto")} onClick={() => setState("read")}>
              Back to reviews
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
